import { render, staticRenderFns } from "./ServerSideResult.vue?vue&type=template&id=6c28c301&"
import script from "./ServerSideResult.vue?vue&type=script&lang=js&"
export * from "./ServerSideResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports